import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class ProductRecentlyViewed extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    this.#load();
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  async #load() {
    const currentProductId = this.dataset.currentProductId;
    const sectionId = this.dataset.sectionId;
    const list = this.querySelector('[data-recently-viewed-items]');
    if (!sectionId || !(list instanceof HTMLUListElement)) return;

    const productIds = RecentlyViewed.getProducts()
      .filter((id) => id !== currentProductId)
      .slice(0, 4);
    if (productIds.length === 0) return;

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    try {
      const markup = await sectionRenderer.getSectionHTML(sectionId, false, url);
      if (this.#abortController.signal.aborted) return;

      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const sourceItems = parsed.querySelectorAll('#predictive-search-products ul > li');
      if (sourceItems.length === 0) return;

      for (const item of sourceItems) {
        list.append(item.cloneNode(true));
      }
      this.hidden = false;
    } catch (error) {
      if (error?.name !== 'AbortError') {
        console.warn('[product-recently-viewed] Unable to load products.');
      }
    }
  }
}

if (!customElements.get('product-recently-viewed')) {
  customElements.define('product-recently-viewed', ProductRecentlyViewed);
}
